<template>
  <div class="app">
    <header class="header">
      <div class="container header-inner">
        <router-link
          to="/"
          class="brand"
        >
          <img
            src="/logo.png"
            alt="CDGC"
            class="brand-logo"
          >
        </router-link>
        <nav class="nav">
          <router-link
            class="nav-link"
            to="/"
            exact-active-class="nav-link-active"
          >
            首页
          </router-link>
          <a
            class="nav-link"
            href="#players"
            @click.prevent="scrollTo('players')"
          >
            会员排行
          </a>
          <a
            class="nav-link"
            href="#events"
            @click.prevent="scrollTo('events')"
          >
            赛事
          </a>
          <a
            class="nav-link"
            href="#courses"
            @click.prevent="scrollTo('courses')"
          >
            场地
          </a>
          <a
            class="nav-link"
            href="#clubs"
            @click.prevent="scrollTo('clubs')"
          >
            俱乐部
          </a>
          <router-link
            class="nav-link"
            to="/rules"
            active-class="nav-link-active"
          >
            规则
          </router-link>
        </nav>
      </div>
    </header>

    <main class="main">
      <router-view class="page-content" />
    </main>

    <footer class="footer">
      <div class="container footer-inner">
        <div class="footer-line">
          Copyright © 2026 CDGC All Rights Reserved.
        </div>
        <div class="footer-line">
          <a
            href="https://beian.miit.gov.cn/"
            target="_blank"
            rel="noopener noreferrer"
          >沪ICP备2024042192号</a>
        </div>
      </div>
    </footer>

    <!-- 小程序二维码弹窗 -->
    <div
      v-if="qrVisible"
      class="qr-mask"
      @click.self="qrVisible = false"
    >
      <div class="qr-dialog">
        <button
          class="qr-close"
          aria-label="关闭"
          @click="qrVisible = false"
        >
          ×
        </button>
        <div class="qr-title">
          {{ qrTitle }}
        </div>
        <div class="qr-sub">
          微信扫码查看详情
        </div>
        <div class="qr-img-wrap">
          <img
            :src="qrImage"
            alt="小程序二维码"
            class="qr-img"
            @error="onQrError"
            @load="onQrLoad"
          >
          <div
            v-if="qrError"
            class="qr-fallback"
          >
            二维码加载失败
          </div>
        </div>
        <div class="qr-tip">
          请使用微信扫一扫
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { eventBus } from './eventBus';

// 二维码图片放在 web/public/qrcode.jpg（通过 /qrcode.jpg 直接访问）
const qrImageUrl = '/qrcode.jpg';

export default {
  name: 'App',
  data() {
    return {
      qrVisible: false,
      qrTitle: '扫码查看详情',
      qrImage: qrImageUrl,
      qrError: false,
    };
  },
  watch: {
    qrVisible(v) {
      if (!v) document.body.style.overflow = '';
    },
  },
  created() {
    // 全局监听：通过 eventBus 接收任意组件的弹二维码请求
    eventBus.$on('show-qr', this.showQr);
  },
  beforeDestroy() {
    eventBus.$off('show-qr', this.showQr);
  },
  methods: {
    scrollTo(id) {
      // 等当前路由动画/布局稳定后再滚动
      this.$nextTick(() => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    },
    showQr(title) {
      this.qrTitle = title || '扫码查看详情';
      this.qrError = false;
      this.qrVisible = true;
      document.body.style.overflow = 'hidden';
      console.log('[showQr]', { title, qrVisible: this.qrVisible, qrTitle: this.qrTitle });
    },
    onQrError() {
      this.qrError = true;
    },
    onQrLoad() {
      this.qrError = false;
    },
  },
};
</script>

<style scoped>
.header {
  position: sticky;
  top: 0;
  z-index: 10;
  background: #00bebe;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
}

.header-inner {
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.brand {
  font-weight: 800;
  letter-spacing: 0.4px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  text-decoration: none;
  flex-shrink: 0;
}
.brand-logo {
  height: 36px;
  width: auto;
  display: block;
}

.nav {
  display: flex;
  align-items: center;
  gap: 6px;
  flex: 1 1 auto;
  min-width: 0;
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;
  justify-content: flex-end;
}
.nav::-webkit-scrollbar {
  display: none;
}

.nav-link {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.85);
  padding: 8px 10px;
  border-radius: 999px;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
}

@media (max-width: 640px) {
  .header-inner {
    height: 56px;
    gap: 8px;
  }
  .brand-logo {
    height: 30px;
  }
  .nav {
    gap: 4px;
  }
  .nav-link {
    font-size: 13px;
    padding: 6px 10px;
  }
}

.nav-link:hover {
  color: #fff;
  background: rgba(255, 255, 255, 0.18);
}

.nav-link.nav-link-active {
  color: #fff;
  background: rgba(255, 255, 255, 0.22);
  font-weight: 600;
}

.main {
  min-height: calc(100vh - 64px - 64px);
}

.page-content {
  padding: 18px 0 28px;
}

.page-content.full-height {
  padding: 0;
}

.footer {
  border-top: 1px solid var(--border);
  padding: 18px 0;
  color: var(--muted);
}
.footer-inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  text-align: center;
  font-size: 13px;
}
.footer-line a {
  color: var(--muted);
  text-decoration: none;
}
.footer-line a:hover {
  color: var(--text);
  text-decoration: underline;
}

/* 二维码弹窗 */
.qr-mask {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.55);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}
.qr-dialog {
  position: relative;
  width: min(320px, 90vw);
  background: #fff;
  border-radius: 20px;
  padding: 28px 24px 22px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);
  text-align: center;
  animation: qr-pop 0.18s ease-out;
}
@keyframes qr-pop {
  from { transform: scale(0.92); opacity: 0; }
  to   { transform: scale(1); opacity: 1; }
}
.qr-close {
  position: absolute;
  top: 8px;
  right: 12px;
  width: 32px;
  height: 32px;
  border: none;
  background: transparent;
  font-size: 24px;
  line-height: 1;
  color: var(--muted);
  cursor: pointer;
  border-radius: 999px;
}
.qr-close:hover {
  background: rgba(0, 0, 0, 0.06);
  color: var(--text);
}
.qr-title {
  font-size: 17px;
  font-weight: 700;
  color: var(--text);
}
.qr-sub {
  margin-top: 6px;
  font-size: 13px;
  color: var(--muted);
}
.qr-img-wrap {
  margin: 18px auto 12px;
  width: 200px;
  height: 200px;
  border-radius: 12px;
  background: #f8fafc;
  border: 1px solid var(--border);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.qr-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.qr-fallback {
  color: var(--muted);
  font-size: 13px;
}
.qr-tip {
  font-size: 12px;
  color: var(--muted);
}
</style>